import { HttpErrorResponse } from '@angular/common/http';
import { AppError } from '@rms/sdk/errors';

export class PartnerSlugInUseError extends AppError {
  constructor(error: HttpErrorResponse) {
    super(error, 'partners.errors.slug-in-use');
  }
}

export class PartnerEmailInUseError extends AppError {
  constructor(error: HttpErrorResponse) {
    super(error, 'partners.errors.email-in-use');
  }
}
